import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`

const axiosInstance = axios.create()

export const getUserAuthStatus = async (salusUserId) => {
  const res = await axios.get(`${baseUrl}/salus-user/user-group`, {
    params: {
      salusUserId: salusUserId,
    },
  })
  console.log('authStatus::', res.data)
  return res.data
}

export const getApprovalList = async (param) => {
  const res = await axios.get(`${baseUrl}/salus-proposal/list`, {
    params: param,
  })
  return res.data
}
export const getApprovalDetail = async (param) => {
  const res = await axios.get(`${baseUrl}/salus-proposal/detail`, {
    params: param,
  })
  return res.data
}

export const updateApproval = async (proposalId, param) => {
  const res = await axios.put(`${baseUrl}/salus-proposal/${proposalId}`, param)
  return res.data
}

export const deleteApproval = async (proposalId) => {
  const res = await axios.delete(`${baseUrl}/salus-proposal/${proposalId}`)
  return res.data
}

export const createApproval = async (param) => {
  const res = await axios.post(`${baseUrl}/salus-proposal/new`, param)
  return res
}

export const approveApproval = async (param) => {
  const res = await axios.post(`${baseUrl}/salus-proposal/accept`, param)
  return res.data
}

export const holdApproval = async (param) => {
  const res = await axios.post(`${baseUrl}/salus-proposal/hold`, param)
  return res.data
}

export const addAopsMember = async (param) => {
  const res = await axios.post(
    `${baseUrl}/salus-user/register-by-admin`,
    {},
    {
      params: param,
    },
  )
  return res.data
}

export const getSalusUserGroupList = async (param) => {
  const res = await axios.get(`${baseUrl}/salus-user/user-groups`)
  return res.data
}

//초안
export const createDraftApproval = async (param) => {
  const res = await axios.post(`${baseUrl}/salus-proposal/drafts`, param)
  return res.data
}

export const updateDraftApproval = async (proposalId, param) => {
  const res = await axios.put(
    `${baseUrl}/salus-proposal/drafts/${proposalId}`,
    param,
  )
  return res.data
}

//  🔥 DRAFT -> PENDING
export const submitDraftApproval = async (proposalId, submitterId) => {
  const res = await axios.post(
    `${baseUrl}/salus-proposal/drafts/${proposalId}/submit?submitterId=${submitterId}`,
  )
  return res.data
}

export const getSalusUserDetail = async (param) => {
  const res = await axios.get(`${baseUrl}/salus-user/user-detail`, {
    params: param,
  })
  return res.data
}

export const getApprovalListForChief = async () => {
  const res = await axios.get(`${baseUrl}/salus-proposal/list/group-by-studio`)
  return res.data
}
